let remark = {
    remarkVersion: 0,
    //用于获取团队备注名称映射表    notice为真时，通知其他端进行请求
    async getTeamMemberName(notice, id, name) {
        let url = `${window.baseURL}/api/account/team_settings?team_id=${localStorage.teamId}&settings_type=web_main`

        let res = await axios.get(url)
        if (res.data.result) {
            localStorage.setItem("remarkTable", res.data.result)
            if (notice) {
                let data = {
                    id,
                    name
                }
                vm.eventHub.$emit("remarkRefresh", data)
                window.g.remarkVersion++
            }
            return res.data.result
        } else {
            localStorage.setItem("remarkTable", "{}")
            return {}
        }
    },
    /**
     *  获取用户备注名
     *  传入参数：用户id，用户名，设置优先显示的格式：remark | name | all, version版本号,必须传一个被vue坚持的数据，用于驱动页面刷新
     */
    getRemarkName(id, name, version, type = "name") {
        if (id) {
            if (localStorage.remarkTable && localStorage.remarkTable !== "null") {
                var table = JSON.parse(localStorage.remarkTable)
            } else {
                var table = this.getTeamMemberName()
            }

            let tableKey = Object.keys(table)

            if (tableKey.length) {
                var key = tableKey.filter(item => {
                    return item === id
                })
                switch (type) {
                    case "remark":
                        return table[key] ? table[key] : ""
                    case "all":
                        return table[key] ? `${table[key]}(${name})` : name
                    case "name":
                        return table[key] ? table[key] : name
                }
            } else {
                return name
            }
        } else {
            return name
        }
    }
}

export default remark
